import { render, staticRenderFns } from "./LoginComponentMessage.vue?vue&type=template&id=a5c7a8a2"
import script from "./LoginComponentMessage.vue?vue&type=script&lang=ts"
export * from "./LoginComponentMessage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports